import React from "react";
import "./Hotel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


export const Hotel = () => {
  const hotels = [
    {
      name: "R S Grand Hotel And Restaurant",
      description:
        "A luxurious stay with an amazing view of the sunrise. Perfect for family vacations and romantic getaways.",
      images: [
        require("../media/tourism/Hotels/R S Grand/1.jpg"),
        require("../media/tourism/Hotels/R S Grand/2.jpg"),
        require("../media/tourism/Hotels/R S Grand/3.jpg"),
        require("../media/tourism/Hotels/R S Grand/4.jpg"),
        require("../media/tourism/Hotels/R S Grand/5.jpg"),
        require("../media/tourism/Hotels/R S Grand/6.jpg"),
      ],
    },
    {
      name: "Wildlife Resorts/ Tent",
      description:
        "A luxurious stay with an amazing view of the sunrise. Perfect for family vacations and romantic getaways.",
      images: [
        require("../media/tourism/Hotels/Wildlife Resort/1.jpeg"),
        require("../media/tourism/Hotels/Wildlife Resort/2.jpeg"),
        require("../media/tourism/Hotels/Wildlife Resort/3.jpeg"),
        require("../media/tourism/Hotels/Wildlife Resort/4.jpeg"),
        require("../media/tourism/Hotels/Wildlife Resort/5.jpeg"),
        require("../media/tourism/Hotels/Wildlife Resort/6.jpeg"),
      ],
    },
    {
      name: "Hotel Desire",
      description:
        "Nestled in the mountains, this hotel offers peace and tranquility away from the hustle of city life.",
      images: [
        require("../media/tourism/Hotels/desire/h1.jpeg"),
        require("../media/tourism/Hotels/desire/h2.jpeg"),
        require("../media/tourism/Hotels/desire/h3.jpeg"),
      ],
    },
    {
      name: "Hotel Standard",
      description:
        "A luxurious stay with an amazing view of the sunrise. Perfect for family vacations and romantic getaways.",
      images: [
        require("../media/tourism/Hotels/Standard/h1.jpeg"),
        require("../media/tourism/Hotels/Standard/h2.jpeg"),
        require("../media/tourism/Hotels/Standard/h3.jpeg"),
      ],
    },
    
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    
  };

  return (
    <div className="hotel-page">
      <h1 className="page-heading">Our Hotel Partners</h1>
      <div className="hotel-list">
        {hotels.map((hotel, index) => (
          <div className="hotel-card" key={index}>
            <h2 className="hotel-name">{hotel.name}</h2>
            {/* <p className="hotel-description">{hotel.description}</p> */}
            <Slider {...sliderSettings} className="hotel-slider">
            {/* <div className="hotel-images"> */}
              {hotel.images.map((image, idx) => (
                <img
                  key={idx}
                  src={image}
                  alt={`${hotel.name} ${idx + 1}`}
                  className="hotel-image"
                />
              ))}
              </Slider>
            </div>
          // </div>
        ))}
      </div>
    </div>
  );
};
